import React, { useState } from 'react';
import ColumnMenu from '../shared/ColumnMenu';
import {
  Grid,
  GridColumn,
  GridColumnMenuFilter,
} from '@progress/kendo-react-grid';
import { process } from '@progress/kendo-data-query';
import { locale } from '../../common/localization/localizationService';

export interface IAutoSequeceRouteGridProps {
  data?: Array<any>;
  className?: string;
}

export default function AutoSequeceRouteGrid(
  props: IAutoSequeceRouteGridProps
): JSX.Element {
  const [dataState, setDataState] = useState({
    sort: [{ dir: 'asc', field: 'time' }],
    take: 26,
    skip: 0,
  });
  const dataStateChange = (event: any) => {
    setDataState(event.data);
  };

  const columnProps = (field: string) => {
    return {
      field: field,
      columnMenu: ColumnMenu,
      headerClassName: isColumnActive(field, dataState) ? 'active' : '',
    };
  };

  const isColumnActive = (field: string, dataState: any) => {
    return GridColumnMenuFilter.active(field, dataState.filter);
  };

  const gridData = props.data.map((seq) => {
    seq.time = new Date(seq.time);
    return seq;
  });
  const result = process(gridData, dataState);
  return (
    <>
      <Grid
        {...dataState}
        className={`customer-logs-grid ${props.className}`}
        data={result}
        selectedField="selected"
        pageable
        resizable
        pageSize={26}
        onDataStateChange={dataStateChange}
        sortable
      >
        <GridColumn
          {...columnProps('oldSequence')}
          title={locale.autoSequenceRoute._oldSequence}
          sortable
          filter="text"
          width={100}
        />
        <GridColumn
          {...columnProps('newSeq')}
          title={locale.autoSequenceRoute._newSequence}
          sortable
          filter="text"
          width={100}
        />
        <GridColumn
          {...columnProps('customerId')}
          title={locale.autoSequenceRoute._customerId}
          sortable
          filter="text"
          width={100}
        />
        <GridColumn
          {...columnProps('time')}
          title={locale.autoSequenceRoute._time}
          format={'{0:' + locale.general._fullDateWithTime + '}'}
          width={150}
          sortable
          filter="date"
        />
        <GridColumn
          {...columnProps('routeLineId')}
          title={locale.autoSequenceRoute._routeLineId}
          width={100}
          sortable
          filter="text"
        />
        <GridColumn
          {...columnProps('route')}
          title={locale.autoSequenceRoute._route}
          width={100}
          sortable
          filter="text"
        />
        <GridColumn
          {...columnProps('orderId')}
          title={locale.autoSequenceRoute._orderId}
          width={100}
          sortable
          filter="text"
        />
        <GridColumn
          {...columnProps('paSystem')}
          title={locale.autoSequenceRoute._paSystem}
          width={100}
          sortable
          filter="text"
        />
      </Grid>
    </>
  );
}
